import "./index.css";
import type { ITypographyProps, ITypographyVariant } from "./types";
import type { ElementType } from "react";
import { clsx } from "clsx";
import type { ISkeletonProps } from "../Skeleton/types";
import { Skeleton } from "../Skeleton";

export const Typography = <T extends ElementType = "span">({
  as: Component = "span",
  variant = "body",
  weight = "regular",
  color = "",
  text,
  children,
  loading,
  skeletonProps,
  ...props
}: ITypographyProps<T>) => {
  const rootClass = clsx(
    `nuco-typography--${variant}`,
    color && `nuco-typography--${color}`,
    weight,
    props.className,
  );

  const skeletonHeight: Record<ITypographyVariant, ISkeletonProps> = {
    h1: {
      height: "43.2px",
    },
    h2: {
      height: "38.4px",
    },
    h3: {
      height: "31.2px",
    },
    h4: {
      height: "26px",
    },
    h5: {
      height: "24px",
    },
    headline: {
      height: "24px",
    },
    body: {
      height: "21px",
    },
    subtitle: {
      height: "18px",
    },
    caption: {
      height: "15px",
    },
    footnote: {
      height: "12px",
    },
    "button-sm": {
      height: "18px",
    },
    "button-md": {
      height: "21px",
    },
  };

  const skeletonFinalProps = {
    ...skeletonHeight[variant as ITypographyVariant],
    ...skeletonProps,
  };

  return (
    <Component {...props} className={rootClass}>
      {loading ? <Skeleton {...skeletonFinalProps} /> : children || text}
    </Component>
  );
};
